import { render, staticRenderFns } from "./articalBox.vue?vue&type=template&id=65dfabf3&scoped=true&"
import script from "./articalBox.vue?vue&type=script&lang=js&"
export * from "./articalBox.vue?vue&type=script&lang=js&"
import style0 from "./articalBox.vue?vue&type=style&index=0&id=65dfabf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfabf3",
  null
  
)

export default component.exports